<template>
  <header id="header" class="site-header header-style-5">
    <div class="topbar topbar-style-2">
      <div class="container">
        <div class="row">
          <div class="col col-sm-5 col-md-offset-7">
            <div class="usefull-links">
              <ul>
                <li>
                  <router-link to="/inox-304-316" title="Inox 304 et inox 316">Inox 304 et 316</router-link>
                </li>
                <li>
                  <router-link to="/entretien" title="Entretien de l'inox">L'entretien de l'inox</router-link>
                </li>
                <li>
                  <router-link to="/videos" title="Videos d'installation de garde corps">Vidéos</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lower-topbar">
      <div class="container">
        <div class="row">
          <div class="col col-sm-3">
            <div class="site-logo">
              <router-link to="/" title="page d'accueil Oxynov">
                <img src="../assets/images/oxynov-logo.svg" alt="logo oxynov spécialiste du garde corps" width="211" height="49">
              </router-link>
            </div>
          </div>
          <div class="col col-sm-9">
            <div class="awards">
              <div>
                <div class="icon"><i class="fi flaticon-title"></i></div>
                <div class="award-info">
                  <div>INOX Certifié</div>
                  <p>ISO 9001</p>
                </div>
              </div>
              <div>
                <div class="icon"><i class="fi flaticon-medal"></i></div>
                <div class="award-info">
                  <div>Oxynov 3D</div>
                  <p>Logiciel 3D gratuit en ligne</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav id="navbar" class="navigation navbar navbar-default original">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="open-btn" @click="openMobileNav()">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="navbar-collapse collapse navigation-holder" :class="{ slideInn: mobileNavbarOpened }">
          <button class="close-navbar" @click="closeMobileNav()"><i class="fa fa-close"></i></button>
          <ul class="nav navbar-nav">
            <li>
              <router-link to="/" @click.native="closeMobileNav" title="Accueil" active-class="active" exact>Accueil</router-link>
            </li>
            <li>
              <router-link to="/concept" @click.native="closeMobileNav" title="Concept oxynov" active-class="active" exact>Concept</router-link>
            </li>
            <li>
              <router-link to="/modeles" @click.native="closeMobileNav" title="Modèles de garde-corps inox" active-class="active" exact>Modèles</router-link>
            </li>
            <li>
              <router-link to="/installation" @click.native="closeMobileNav" title="installation des garde-corps inox" active-class="active" exact>Installation</router-link>
            </li>
            <li>
              <router-link to="/faq" @click.native="closeMobileNav" title="Foire aux questions" active-class="active" exact>Faq</router-link>
            </li>
            <li>
              <router-link to="/photos" @click.native="closeMobileNav" title="Photos de réalisation de garde corps inox" active-class="active" exact>Photos</router-link>
            </li>
          </ul>
        </div>
        <a href="https://mon-devis.deck-linea.com/devis/garde-corps?utm_source=www.oxynov.fr" target="_blank" @click.native="closeMobileNav" title="Réalisez votre devis garde-corps" class="theme-btn-s2 request-quote shop" style="right: 140px;color: #fff;" active-class="active" exact>Devis gratuit</a>
        <a href="https://www.deck-linea.com/92-garde-corps-inox" target="_blank" title="Réalisez votre devis garde-corps" class="theme-btn-s2 request-quote" style="color:#fff;background: #68838f;">La boutique</a>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      mobileNavbarOpened: false
    }
  },
  methods: {
    openMobileNav () {
      if (!this.mobileNavbarOpened) {
        this.mobileNavbarOpened = true
      }
    },
    closeMobileNav () {
      this.mobileNavbarOpened = false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.award-info div {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  color: #051829;
  font-size: 1.06667rem;
  margin: 0;
}
#navbar {
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
  z-index: 1;
}
.navbar.affix {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
.header-style-5 .request-quote:focus:active {
  color: #fff;
}
@media only screen and (max-width : 992px) {
  .header-style-5 .lower-topbar .site-logo {
    z-index: 1!important;
  }
  .site-header .navigation {
    position: relative!important;
    height: 65px!important;
    width: 100%!important;
    left: 0!important;
  }
  .site-header #navbar .navbar-nav {
    display: none;
  }
  .site-header #navbar .close-navbar {
    display: none;
  }
  .header-style-5 .shop {
    right: auto;
    left: 155px;
  }
  .site-header .slideInn {
    right: 0 !important;
    background: #fff;
    display: block !important;
    width: 280px;
    height: 100% !important;
    margin: 0;
    padding: 0;
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .site-header .slideInn .navbar-nav {
    display: block!important;
  }
  .site-header .navbar-collapse.slideInn .close-navbar {
    display: block!important;
  }
  .site-header .navbar-nav > li {
    border-bottom: 1px solid #cccccc;
  }
  .site-header #navbar ul a {
    color: #000;
    font-size: 0.93333rem;
    padding: 10px 15px 10px 35px;
  }
}
@media only screen and (max-width : 768px) {
  .awards {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue